export default __webpack_public_path__ + "resources/icons/n411-50c1.png";